import * as Yup from 'yup';

const validationSchema = ({ t }) => Yup.object().shape({
  name: Yup.string()
    .typeError('field must be string !')
    .required('cannot empty'),
  level: Yup.string()
    .typeError('field must be string !')
    .required('cannot empty'),
  description: Yup.string()
    .typeError('field must be string !')
    .required('cannot empty'),
  status: Yup.string()
    .typeError('field must be string !')
    .required('cannot empty'),
});

export default validationSchema;
